import React from "react";
import { ArrowRight } from "lucide-react";
import CommonButton from "../../ui/inputs/CommonButton.js";
import { Box } from "@mui/material";
import { heroArrowAnimation } from "../index.js";

const HeroActions = ({ history }) => {
  return (
    <Box
      className="home-hero-actions"
      sx={{
        display: "flex",
        gap: { xs: 1.25, sm: 2, md: 3 },
        flexWrap: "wrap",
        width: "100%",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "stretch", sm: "center" },
      }}
    >
      <CommonButton
        variant="contained"
        size="hero"
        onClick={() => (window.location.href = "#game-arena")}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1.5,
          width: { xs: "100%", sm: "auto" },
          minHeight: { xs: "52px", sm: "60px", md: "64px" },
          px: { sm: 4, md: 5 },
          fontSize: { sm: "1.1rem", md: "1.15rem" },
          ...heroArrowAnimation,
        }}
      >
        Play Now
        <Box
          component="span"
          className="hero-arrow"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "visible",
            width: "18px",
            height: "18px",
            flexShrink: 0,
            color: (theme) => theme.palette.primary.contrastText,
          }}
        >
          <ArrowRight size={18} strokeWidth={2.5} />
        </Box>
      </CommonButton>

      <CommonButton
        variant="outlined"
        size="hero"
        onClick={() => history.push("/all-lotteries")}
        sx={{
          color: (theme) => theme.custom.colors.alpha.black[85],
          borderColor: (theme) => theme.custom.colors.alpha.black[30],
          width: { xs: "100%", sm: "auto" },
          minHeight: { xs: "52px", sm: "60px", md: "64px" },
          px: { sm: 4, md: 5 },
          fontSize: { sm: "1.1rem", md: "1.15rem" },
          "&:hover": {
            backgroundColor: (theme) => theme.custom.colors.alpha.black[10],
            borderColor: (theme) => theme.custom.colors.alpha.black[60],
          },
        }}
      >
        Browse all games
      </CommonButton>
    </Box>
  );
};

export default HeroActions;